export	default  {
    beneficiary_label: 'Beneficiary:',
    beneficiary: 'GL events Live（ShenZhen）Co.,Ltd.',
    bank_label: 'Bank:',
    bank: 'CHINA MERCHANTS BANK CHEGONGMIAO SUB-BRANCH',
    account_label: 'Account:',
    account: '755942217610805',
    pay_notice: 'Please pay in time so that the order can be processed as soon as possible',
    download: 'Download the rent advance list',
    order_num: 'The order no:',
    unit: 'RMB',
    tip_notice: 'Note: please remember the following information when making remittance.',
    tip_pay_1: '1. Please remit the pending payment to the above establishment account through the bank before',
    tip_pay_2: 'The billing cycle is generally 1-3 working days.',
    tip_remit_1: '1、 Please keep the remittance amount in line with the amount payable. Do not remit more or less. Please remit as soon as possible. Late orders will be cancelled automatically',
    tip_remit_2: 'please fill this identification number into the money order when you remit money',
    tip_remit_3: '【postscript】',
    tip_remit_4: 'In the postscript column (only fill in this identification code). Failure to fill in will affect the order confirmation time. Your remittance identification number has been sent.',
    tip_num: '3. The remittance amount should be consistent with the payable amount. Please do not remit more or less.',
    tip_web_1: '4. Please contact us if the website order is not updated to "paid" status within 5 working days after remittance',
    tip_web_2: 'If the "unpaid" status of the order does not pay within the specified time or does not contact us, the order will be regarded as invalid, our company will not be responsible',
    tip_warm: '5. Online pre-rent will not send SMS or link to you in the name of invalid order, abnormal order or system upgrade to ask you to provide bank card and verification code information. Please strengthen your awareness of prevention and guard against fraud.',
    tip_order: '6. When the payment is completed, if you need to modify the order content, please order again after the order is cancelled by the order center.',
    tip_image: 'Filling diagram of remittance application form: in order to complete the offline remittance smoothly, please fill in the remittance identification code correctly in the column of remittance purpose',
    back: 'Return to order center',
    '请您尽快付款，以便订单及时处理':'Please pay as soon as possible so that orders can be processed in time',
    '联系人姓名':'Name of contact person',
    '联系电话':'Contact number',
    '支付方式':'Payment method',
    '应付金额':'Amount payable',
    '汇款信息':'Remittance Information',
    '汇款截止时间':'Remittance deadline',
    '汇款账号信息':'Remittance account information',
    '汇款识别码':'Remittance Identification Code',
    '请将付款识别码填写到汇款单附言栏':'Please fill in the payment identification number in the appendix of the remittance slip',
    '注意事项':'Matters needing attention',
    '订单信息':'Order information',
    '线下付款':'Offline payment'
  }


// WEBPACK FOOTER //
// ./src/i18n/en-us/feeOfflinePayment.js